import { canDownload, canRead, canWrite } from '../access/rbacAccess'

export const SETTLEMENTS = {
  LIST: 'ejecuta.settlements',
  DAILY_CONTROL: 'ejecuta.settlements.show.daily_control_tab',
  APPROVAL_TAB: 'ejecuta.settlements.show.approval_tab'
}

export const canViewSettlements = () => canRead(SETTLEMENTS.LIST)

export const canViewDailySettlementControl = () =>
  canViewSettlements() && canRead(SETTLEMENTS.DAILY_CONTROL)

export const canDownloadDailySettlementControl = () => canDownload(SETTLEMENTS.DAILY_CONTROL)

export const canManageSettlements = () => canWrite(SETTLEMENTS.LIST)

export const canDownloadSettlements = () => canDownload(SETTLEMENTS.LIST)

export const canViewSettlementApproval = () => canRead(SETTLEMENTS.APPROVAL_TAB)

export const canManageSettlementApproval = () => canWrite(SETTLEMENTS.APPROVAL_TAB)

/** Tab de cobros anulados en detalle de liquidación (antes `see_annulled_charges_collection`). */
export const canViewAnnulledSettlementCharges = () => canViewSettlements()
